<template>
    <div class="news-list-wrapper">
        <div class="news-list-item" v-for="item in list" :key="item.itemId">
            <a @click.prevent="goPage(item)" href="">
                <h4>
                    <span v-html="item.itemTitle"></span>
                </h4>
                <div class="img">
                    <img :src="slimImg(item.imgUrl)" @load="imgLoad" @error="imgError" alt="">
                    <span v-if="item.itemType == 1"></span>
                    <b v-if="item.itemDuration">{{item.itemDuration | videoTime}}</b>
                    <i v-if="item.label">{{item.label | label}}</i>
                </div>
                <p class="time">{{item.itemPublishTime | timeToMin}}</p>
            </a>
        </div>
    </div>
</template>

<script>

import Moment from 'moment'

import Filters from '@/utils/filters'

import { mapState } from 'vuex'

export default {
    name: 'NewsList',
    props: ['list'],
    computed: {
        ...mapState(['lang'])
    },
    methods: {
        imgLoad (e) {
            e.target.parentNode.style.background = 'none'
        },
        imgError (e) {
            e.target.src = require('../../assets/img/default_img43.jpg')
        },
        goPage (item) {
            const link = Filters.link(item)
            if (this.$Common.isHyperlinks(link)) {
                window.location.href = link
            } else {
                this.$router.push({
                    path: link,
                    query: {
                        lan: this.lang
                    }
                })
            }
        },
        slimImg (img) {
            return this.$Common.slimImg(img, 400)
        }
    },
    filters: {
        timeToMin (time) {
            return Moment(time).format('YYYY/MM/DD HH:mm')
        },
        label (label) {
            return Filters.label(label)
        },
        videoTime (timestamp) {
            return Filters.videoTime(timestamp)
        }
    }
}
</script>

<style lang="scss">
    .news-list-wrapper {
        padding: 0 3.611vw;
        .news-list-item {
            border-bottom: 1px solid #ECF2F5;
            padding: 5vw 0 3.426vw;
            a {
                display: flex;
                text-decoration: none;
                position: relative;
                h4 {
                    flex: 1;
                    span {
                        color: #000;
                        font-size: 4.259vw;
                        font-weight: normal;
                        line-height: 1.4;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 2;
                        word-wrap: break-word;
                    }
                }
                .img {
                    width: 31.25vw;
                    height: 23.438vw;
                    flex-shrink: 0;
                    margin-left: 5.185vw;
                    position: relative;
                    background: #f6f6f6;
                    border-radius: .8vw;
                    overflow: hidden;
                    img {
                        height: 100%;
                    }
                    span {
                        position: absolute;
                        left: 0;
                        top: 0;
                        width: 100%;
                        height: 100%;
                        font-size: 7.407vw;
                        color: #fff;
                        background: url('../../assets/img/video_icon.png') no-repeat center center;
                        background-size: 7.813vw auto;
                    }
                    b {
                        font-size: 5.938vw;
                        color: #fff;
                        font-weight: normal;
                        position: absolute;
                        bottom: 1.042vw;
                        left: 1.719vw;
                        padding: 0 2.083vw;
                        height: 8.542vw;
                        display: flex;
                        align-items: center;
                        transform: scale(.5);
                        transform-origin: left bottom;
                        background-color: rgba(0, 0, 0, .5);
                        border-radius: .8vw;
                    }
                    i {
                        font-size: 2.778vw;
                        font-style: normal;
                        line-break: 1.3;
                        color: #999999;
                        position: absolute;
                        width: 5vw;
                        box-sizing: border-box;
                        top: 0;
                        right: 1.481vw;
                        background-color: #fff;
                        padding: 0.556vw 1.204vw 2.593vw;
                        clip-path: polygon(0 0, 100% 0, 100% 100%, 50% calc(100% - 1.389vw), 50% calc(100% - 1.389vw), 0 100%)
                    }
                }
                .time {
                    font-size: 3.241vw;
                    color: #7E8998;
                    position: absolute;
                    left: 0;
                    bottom: 0;
                    line-height: 1.4;
                }
            }
        }
    }
</style>
